import { useRef } from "react";
import { GalleryIcon, UploadAttachment } from "../../assets/icons/icon";
import styles from "./styles.module.css";

const AppImageUploader = ({
  toggleImageModal,
  handleImage,
  error,
  title,
  image,
  I18n,
  id,
  readOnly,
}) => {
  const inputRef = useRef(null);
  const inputId = id || "app-image-uploader-input";

  const handleUpload = (e) => {
    if (readOnly) return;

    const photos = e.target.files;
    for (const img of photos) {
      const reader = new FileReader();
      reader.readAsDataURL(img);
      reader.onload = function () {
        handleImage(title, reader.result, img);
      };
    }
    e.target.value = "";
  };

  const openFilePicker = () => {
    if (readOnly) return;
    inputRef.current?.click();
  };

  const openImageModal = () => {
    if (!image || !toggleImageModal) return;
    toggleImageModal(true);
  };

  const actionLabel = image
    ? readOnly
      ? I18n.view
      : I18n.change_image
    : I18n.upload_image || title;

  const handleActionClick = () => {
    if (readOnly) {
      openImageModal();
      return;
    }
    openFilePicker();
  };

  return (
    <div className={styles.wrapper}>
      <div
        className={`${styles.imageBox} ${
          image ? styles.imageBoxFilled : styles.imageBoxEmpty
        } ${image && toggleImageModal ? styles.imageBoxClickable : ""}`}
        onClick={openImageModal}
        onKeyDown={(e) => {
          if (e.key === "Enter" && image && toggleImageModal) {
            e.preventDefault();
            openImageModal();
          }
        }}
        role={image && toggleImageModal ? "button" : undefined}
        tabIndex={image && toggleImageModal ? 0 : undefined}
      >
        {image ? (
          <img src={image} alt="" title="Stock image" className={styles.previewImage} />
        ) : (
          <GalleryIcon className={styles.placeholderIcon} aria-hidden="true" />
        )}
      </div>

      <div className={styles.actionArea}>
        {!readOnly || image ? (
          <button
            type="button"
            className={styles.actionButton}
            onClick={handleActionClick}
            id={id ? `${id}_action` : undefined}
          >
            {!readOnly && (
              <UploadAttachment className={styles.uploadIcon} aria-hidden="true" />
            )}
            <span>{actionLabel}</span>
          </button>
        ) : null}

        <p className={styles.helperText}>
          {I18n.jpg_png_file_size_no_more_than}
        </p>

        {error ? <p className={styles.error}>{error}</p> : null}
      </div>

      <input
        ref={inputRef}
        onChange={handleUpload}
        accept="image/*"
        id={inputId}
        type="file"
        className={styles.hiddenInput}
      />
    </div>
  );
};

export default AppImageUploader;
